import { render } from "./CartButton.vue?vue&type=template&id=42f970bc&scoped=true&ts=true"
import script from "./CartButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartButton.vue?vue&type=script&setup=true&lang=ts"

import "./CartButton.vue?vue&type=style&index=0&id=42f970bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f970bc"],['__file',"src/components/CartButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42f970bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42f970bc', __exports__)) {
    api.reload('42f970bc', __exports__)
  }
  
  module.hot.accept("./CartButton.vue?vue&type=template&id=42f970bc&scoped=true&ts=true", () => {
    api.rerender('42f970bc', render)
  })

}


export default __exports__